import AttributeMappingApi from "../../services/api/AttributeMapping";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import Errors from "../../constants/Errors.json";
import _ from "lodash-es";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("Error in Attribute Mappings:", err);
}

export const setUserAttributeList = (payload) => {
  return {
    type: ActionTypes.SET_USER_ATTRIBUTE_LIST,
    payload,
  };
};

export const setActionList = (payload) => {
  return {
    type: ActionTypes.SET_ACTION_TYPE_LIST,
    payload,
  };
};

export const setUserId = (payload) => {
  return {
    type: ActionTypes.SET_USER_ID,
    payload,
  };
};

export const setActionAttributeMapping = (payload) => {
  return {
    type: ActionTypes.SET_ACTION_ATTRIBUTE_MAPPING,
    payload,
  };
};

export const updateAttributeValues = (payload) => {
  return {
    type: ActionTypes.UPDATE_ATTRIBUTE_VALUES,
    payload,
  };
};

export const getUserAttributeList = (user_id, action) => async (dispatch) => {
  try {
    let queryParams = `user_id=${user_id}&action=${action}`;
    dispatch(setLoader(true));
    let response = await AttributeMappingApi.getUserAttributeList(queryParams);
    dispatch(setLoader(false));
    if (response && response.status["code"] === 200) {
      dispatch(setUserAttributeList(response.user_attribute_list));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        tyep: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getActionTypeList = (email_id) => async (dispatch) => {
  try {
    let queryParams = `email_id=${email_id}`;
    dispatch(setLoader(true));
    let response = await AttributeMappingApi.getActionTypeList(queryParams);
    dispatch(setLoader(false));
    if (response && response.status["code"] === 200) {
      const actionNames = (response?.action_type ?? []).map(
        (action = {}) => action?.action_name ?? ""
      );
      const actionNameActionTypeMapping = {};
      (response?.action_type ?? []).forEach((action = {}) => {
        actionNameActionTypeMapping[action.action_name] =
          action.attribute_types;
      });
      dispatch(setActionList(actionNames));
      dispatch(setActionAttributeMapping(actionNameActionTypeMapping));
      dispatch(setUserId(response.user_id));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createAttributeMapping =
  (filters = {}, action = "") =>
  async (dispatch) => {
    try {
      let attributeMappingPayload = {
        ..._.cloneDeep(filters),
      };
      dispatch(setLoader(true));
      let response = await AttributeMappingApi.createAttributeMapping(
        attributeMappingPayload
      );
      dispatch(setLoader(false));
      if (response && response.status["code"] === 200) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
          })
        );
        if (action != "") {
          dispatch(getUserAttributeList(filters.user_id, action));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Error.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const updateAttributeMapping =
  (filters = {}, action = "") =>
  async (dispatch) => {
    try {
      let attributeMappingPayload = {
        ..._.cloneDeep(filters),
      };
      dispatch(setLoader(true));
      let response = await AttributeMappingApi.updateAttributeMapping(
        attributeMappingPayload
      );
      dispatch(setLoader(false));
      if (response && response.status["code"] === 200) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
          })
        );
        dispatch(updateAttributeValues(filters));
        if (action != "") {
          dispatch(getUserAttributeList(filters.user_id, action));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors,
        })
      );
      handleError(err);
    }
  };
